import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Statistic, PostCard } from './dashboard';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private branch = 'all';

  constructor(private http: HttpClient) { }

  // TODO: Use `this.branch` to get branch's info
  // private statisticUrl = `api/statistic?branch=${this.branch}`;
  private statisticUrl = 'api/statistic';
  private postCardsUrl = 'api/postCards';

  setBranch (branch: string) {
    this.branch = branch;
  }

  getStatistic (): Observable<Statistic> {
    return this.http.get<Statistic>(this.statisticUrl)
  }

  getBrandCardAnalytics (): Observable<Statistic> {
    return this.http.get<Statistic>(this.statisticUrl)
  }

  getTopPerformers (): Observable<Statistic> {
    return this.http.get<Statistic>(this.statisticUrl)
  }

  getTopDepartments (): Observable<Statistic> {
    return this.http.get<Statistic>(this.statisticUrl)
  }

  getTrending (): Observable<Statistic> {
    return this.http.get<Statistic>(this.statisticUrl)
  }

  getNewConnects (): Observable<Statistic> {
    return this.http.get<Statistic>(this.statisticUrl)
  }

  getPostCards (): Observable<PostCard[]> {
    return this.http.get<PostCard[]>(this.postCardsUrl)
  }

}
